// extracted by mini-css-extract-plugin
export var activeDot = "_7l-c";
export var buttonContainer = "_7l-9";
export var channelButton = "_7l-a";
export var clickable = "_7l-d";
export var content = "_7l-0";
export var contentFull = "_7l-2";
export var contentThird = "_7l-1";
export var contentWrapper = "_7l-7";
export var description = "_7l-5";
export var heightShort = "_7l-f";
export var image = "_7l-3";
export var imageContainer = "_7l-4";
export var selectButton = "_7l-e";
export var spinnerContainer = "_7l-b";
export var titleContent = "_7l-8";
export var titleWrapper = "_7l-6";